<template>
</template>
<script>

import { setIdToken, setAccessToken } from '../utils/auth'

export default {
  name: '',
  mounted() {
    this.$nextTick(() => {
      setAccessToken()
      setIdToken()
      window.location.href = '/app.html#/'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/callback.vue